import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { Segment, L, List, Input, Message, Flag, Icon } from 'nallian-shared-ui/lib/components';
import { compose } from 'redux';
import styled from 'styled-components';
import FetchHandlerModule from 'nallian-shared-ui/lib/modules/FetchHandlerModule';
import { withTranslation } from 'react-i18next';
import privateVehiclesSearchService from '../services/privateVehiclesSearchService';
import CountryName from '../../app/components/CountryName';

const SearchResultsSegment = styled(Segment).attrs({})`
  height: calc(100vh - 250px);
  max-height: 250px;
  overflow: auto;
`;

const VehicleRoWDetail = styled.div`
  width: 220px;
  display: inline-block;
  &:last-child {
    width: 100px;
  }
`;

class VehicleSelector extends PureComponent {
  state = {
    licensePlateSearchValue: undefined,
  };

  handleSelectNewVehicle = () => {
    this.props.input.onChange({ licensePlate: this.state.licensePlateSearchValue });
  };

  handleLicensePlateSearchChange = (e, data) => {
    this.setState({ licensePlateSearchValue: data.value });
    this.props.input.onChange({});
    if (data.value && data.value.trim()) {
      this.getDebouncedDispatchPrivateVehiclesSearch()(data.value);
    }
  };

  debouncedDispatchPrivateVehiclesSearch;
  getDebouncedDispatchPrivateVehiclesSearch = () => {
    if (!this.debouncedDispatchPrivateVehiclesSearch) {
      this.debouncedDispatchPrivateVehiclesSearch = debounce(
        this.props.dispatchPrivateVehiclesSearchGet,
        300
      );
    }
    return this.debouncedDispatchPrivateVehiclesSearch;
  };

  render() {
    const { privateVehiclesSearchFetch, input, meta, t } = this.props;
    const { value, onChange } = input;
    const { licensePlateSearchValue } = this.state;
    const strippedLicensePlateSearchValue =
      licensePlateSearchValue && licensePlateSearchValue.toUpperCase().replace(/[^A-Z0-9]/, '');
    return (
      <FetchHandlerModule fetches={[privateVehiclesSearchFetch]}>
        {meta.touched && meta.error && <Message negative>{meta.error}</Message>}
        <Input
          placeholder={t('licensePlate')}
          name="licensePlate"
          loading={privateVehiclesSearchFetch.pending}
          onChange={this.handleLicensePlateSearchChange}
          icon="search"
          fluid
          autoFocus
        />
        <SearchResultsSegment loading={privateVehiclesSearchFetch.pending}>
          <List selection divided>
            {(!licensePlateSearchValue || !licensePlateSearchValue.trim()) && (
              <L.Item description={t('noLicensePlateErr')} disabled />
            )}
            {licensePlateSearchValue &&
              licensePlateSearchValue.trim() &&
              privateVehiclesSearchFetch.fulfilled &&
              privateVehiclesSearchFetch.value.values.filter(
                vehicle => vehicle.licensePlate === strippedLicensePlateSearchValue
              ).length < 1 && (
                <L.Item
                  header={t('createNewVehicle')}
                  description={t('withLicenseplate', {
                    licensePlate: licensePlateSearchValue.trim(),
                  })}
                  active={!!value && !!value.isNew}
                  onClick={this.handleSelectNewVehicle}
                  icon={
                    value && value.licensePlate ? (
                      <Icon name="checkmark" color="green" />
                    ) : (
                      <Icon name="checkmark" placehHolder />
                    )
                  }
                />
              )}
            {licensePlateSearchValue &&
              licensePlateSearchValue.trim() &&
              privateVehiclesSearchFetch.fulfilled &&
              privateVehiclesSearchFetch.value.values.map(vehicle => (
                <L.Item
                  key={vehicle.id}
                  header={vehicle.licensePlate}
                  description={
                    <Fragment>
                      <VehicleRoWDetail>{vehicle.type}</VehicleRoWDetail>
                      <VehicleRoWDetail>{vehicle.owner}</VehicleRoWDetail>
                      <VehicleRoWDetail>
                        <Flag name={vehicle.countryCode.toLowerCase()} />{' '}
                        <CountryName code={vehicle.countryCode} />
                      </VehicleRoWDetail>
                    </Fragment>
                  }
                  icon={
                    value && value.vehicleId === vehicle.id ? (
                      <Icon name="checkmark" color="green" />
                    ) : (
                      <Icon name="checkmark" placehHolder />
                    )
                  }
                  active={!!value && value.vehicleId === vehicle.id}
                  onClick={() => onChange({ vehicleId: vehicle.id })}
                />
              ))}
            {licensePlateSearchValue &&
              licensePlateSearchValue.trim() &&
              privateVehiclesSearchFetch.fulfilled &&
              privateVehiclesSearchFetch.value.values.length <
                privateVehiclesSearchFetch.value.totalCount && (
                <L.Item
                  icon
                  description={t('andXMore', {
                    x:
                      privateVehiclesSearchFetch.value.totalCount -
                      privateVehiclesSearchFetch.value.values.length,
                  })}
                  disabled
                />
              )}
          </List>
        </SearchResultsSegment>
      </FetchHandlerModule>
    );
  }
}

VehicleSelector.propTypes = {
  t: PropTypes.func.isRequired,
  privateVehiclesSearchFetch: PropTypes.object.isRequired,
  dispatchPrivateVehiclesSearchGet: PropTypes.func.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

export default compose(
  withTranslation(),
  privateVehiclesSearchService
)(VehicleSelector);
